import { useEffect } from 'react';
import { useForm, type UseFormReturn } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import type { SuperAdmin } from '../types/super-admin.types';
import { editSuperAdminSchema, type EditSuperAdminFormData } from './EditSuperAdminDialog.utils';

export function useEditSuperAdminForm(
  superAdmin: SuperAdmin | null
): UseFormReturn<EditSuperAdminFormData> {
  const form = useForm<EditSuperAdminFormData>({
    resolver: zodResolver(editSuperAdminSchema),
    defaultValues: { firstName: '', lastName: '', phone: '' },
  });
  const { reset } = form;

  useEffect(() => {
    if (superAdmin)
      reset({
        firstName: superAdmin.profile.firstName,
        lastName: superAdmin.profile.lastName,
        phone: superAdmin.profile.phone ?? '',
      });
  }, [superAdmin, reset]);

  return form;
}
